console.log("Tabletop Goodies - Script - Core");

var TTG = function () {

    const result = {};

    result.Resources =
    {
    }

    result.Context =
    {
        currentLanguageId: "en",
        debugMode: $('body').is(".debug-mode")
    };

    if (typeof TELanguageId !== 'undefined') {
        result.Context.currentLanguageId = TELanguageId;
    }

    result.ApplicationError = class extends Error
    {
        constructor(message, extraInformation) {
            super(message);
            this.name = "ApplicationError";
            this.extraInformation = extraInformation;
        }
    }

    result.shuffleArray = function (array) {
        return array.sort(() => Math.random() - 0.5);
    }

    result.isEmpty = function (value) {
        if (value === null || value === undefined) return true;
        if (value === '') return true;
        if (value instanceof $) {
            return value.length === 0;
        }
        if (typeof (value) === 'string') {
            return value === '';
        }
        return false;
    };


    result.formatStringWithObject = function(format, values, mergeSystemValues = true) {
     if (mergeSystemValues == true) {
       values = Object.assign({}, values);
       values["shopify_language"] = "en";
       if (window.Shopify) {
         if (window.Shopify.locale)
           values["shopify_language"] = window.Shopify.locale;
       }
     }
     return format.replace(/{(\w+)}/g, function (match, key) {
       // Check if the key exists in the values object, if not, leave the placeholder as is
       return key in values ? values[key] : match;
     });
    }
    
    result.getValueByPath = function(obj, path, fallback = undefined) {
       return path.split('.').reduce((current, key) => (current && current[key] !== undefined) ? current[key] : fallback, obj);
    }
  
    result.isEmptyOrWhiteSpaces = function (value) {
        if (value === null || value === undefined) return true;
        if (value === '') return true;
        if (value instanceof $) {
            return value.length === 0;
        }
        if (typeof (value) === 'string') {
            const trimvalue = TE.Strings.trim(value);
            return trimvalue === '';
        }
        return false;
    };

    result.toDefaultValue = function (value, defaultValue) {
        if (value === null || value === undefined) return defaultValue;
        return value;
    }

    result.toNullableValue = function (value) {
        return TE.toDefaultValue(value, null);
    }

    const _generatedIdPossibleFirstCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const _generatedIdPossibleCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    result.generateId = function (length) {
        if (TE.isEmpty(length) || length < 1) length = 20;
        let text = _generatedIdPossibleFirstCharacters.charAt(Math.floor(Math.random() * _generatedIdPossibleFirstCharacters.length));
        for (var i = 1; i < length; i++) {
            text += _generatedIdPossibleCharacters.charAt(Math.floor(Math.random() * _generatedIdPossibleCharacters.length));
        }
        return text;
    };

    if (window.performance.now) {
        result.getTimestamp = function () { return window.performance.now(); };
    } else {
        if (window.performance.webkitNow) {
            result.getTimestamp = function () { return window.performance.webkitNow(); };
        } else {
            result.getTimestamp = function () { return new Date().getTime(); };
        }
    }

    /* ----------------------- */
    /* Type Checks             */
    /* ----------------------- */

    result.isJQuery = function (value) {
        return value !== null && value instanceof jQuery || 'jquery' in Object(value);
    };

    result.isObject = function (value) {
        return value !== null && typeof value === 'object';
    };

    result.isDate = function (value) {
        return value !== null && (value instanceof Date || typeof value === 'date');
    };

    result.isString = function (value) {
        return value !== null && (value instanceof String || typeof value === 'string');
    };

    result.isFunction = function (value) {
        return value !== null && typeof value === 'function';
    };

    result.isNumber = function (value) {
        return value !== null && typeof value === 'number' && !isNaN(value);
    };

    result.isBoolean = function (value) {
        return value !== null && typeof value === 'boolean';
    };

    const _validMacAddressChars = "0123456789ABCDEFabcdef";

    result.isMacAddress = function (value, isStrict = false) {
        if (TE.isString(value)) {
            if (isStrict || value.indexOf(':') > -1) {
                const regex = new RegExp("^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$");
                return regex.test(value);
            }
            else {
                if (value.length === 12) {
                    for (var i = 0; i < value.length; i++) {
                        let c = value.charAt(i);
                        if (_validMacAddressChars.indexOf(c) === -1) {
                            return false;
                        }
                    }
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
            return false;
        }
    }

    result.mergeObjects = (a, b, alreadyComputed) => {
        if (TE.isEmptyOrWhiteSpaces(alreadyComputed)) {
            alreadyComputed = [];
        }
        if (TE.isObject(a) && TE.isObject(b) && !alreadyComputed.includes(b)) {
            alreadyComputed.push(b);
            Object.keys(b).forEach((key) => {
                if (TE.isObject(a[key]) && TE.isObject(b[key] && !Array.isArray(a[key]) && !Array.isArray(b[key]))) {
                    TE.mergeObjects(a[key], b[key], alreadyComputed);
                }
                else {
                    a[key] = b[key];
                }
            });
        }
    }


    return result;

}();

if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}



          



